<template>
  <div>
    <div v-if="loading" class="loading-container">
      <ProgressSpinner />
    </div>
    <div v-else class="baep-container">
      <!-- Header Section -->
      <table class="w-full mb-8 border-collapse">
        <colgroup>
          <col style="width: 50%;">
          <col style="width: 50%;">
        </colgroup>
        <tr>
          <td rowspan="2" class="border border-black px-4">
            <div class="space-y-2">
              <div>
                <span class="font-bold">PEKERJAAN :</span>
                {{ data.nama_pekerjaan }}
              </div>
              <div>
                <span class="font-bold">UNIT KERJA :</span>
                {{ data.nama_unit_kerja }}
              </div>
            </div>
          </td>
          <td class="border border-black px-4 text-center font-bold">
            <div>BERITA ACARA</div>
            <div>EVALUASI PENAWARAN</div>
          </td>
        </tr>
        <tr>
          <td class="border border-black px-4">
            <div class="space-y-2">
              <div>
                <span class="font-bold">NOMOR :</span>
                {{ data.nomor_baep }}
              </div>
              <div>
                <span class="font-bold">TANGGAL :</span>
                {{ data.tanggal_baep }}
              </div>
            </div>
          </td>
        </tr>
      </table>

      <!-- Main Content -->
      <div class="content mb-4">
        <p class="mb-4">
          Pada hari ini <b>{{ data.nama_hari }}</b>, tanggal <b>{{ capitalizeFirst(data.terbilang_hari) }}</b> bulan <b>{{ data.nama_bulan }}</b> tahun <b>{{ capitalizeFirst(data.terbilang_tahun) }}</b>,
          kami yang bertanda tangan di bawah ini, telah mengadakan evaluasi penawaran <b>{{ data.nama_pekerjaan }}</b>,
          menyatakan bahwa :
        </p>

        <!-- Attendees Section -->
        <div class="mb-4">
          <div class="font-bold">I. Hadir dalam rapat :</div>
          <template v-for="(group, role) in groupedAttendees" :key="role">
            <div class="font-bold ml-4">{{ capitalizeFirst(role) }}</div>
            <div v-for="(actor, index) in group" :key="index" class="ml-8">
              {{ index + 1 }}. {{ actor.nama }}
            </div>
          </template>
        </div>

        <!-- Evaluation Results -->
        <div class="mb-4">
          <div class="font-bold mb-2">II. Hasil Evaluasi sebagai berikut :</div>
          <table class="w-full border-collapse border border-gray-400">
            <thead>
              <tr>
                <th class="border border-gray-400 p-2" rowspan="2">No</th>
                <th class="border border-gray-400 p-2" rowspan="2">Nama Perusahaan</th>
                <th class="border border-gray-400 p-2" rowspan="2">
                  PENAWARAN HARGA<br/>
                  (Rp)
                </th>
                <th class="border border-gray-400 p-2" :colspan="data.metode_penilaian.length">
                  KELENGKAPAN DOKUMEN<br/>
                  PENAWARAN
                </th>
                <th class="border border-gray-400 p-2" rowspan="2">Status</th>
                <!-- <th class="border border-gray-400 p-2" rowspan="2">
                  Harga Penawaran<br/>
                  Terkoreksi
                </th> -->
                <th class="border border-gray-400 p-2" rowspan="2">
                  Keterangan
                </th>
              </tr>
              <tr>
                <th v-for="metode in data.metode_penilaian" :key="metode.nama" class="border border-gray-400 p-2">
                  {{ metode.nama }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(hasil, index) in sortedHasilEvaluasi" :key="index">
                <td class="border border-gray-400 p-2">{{ index + 1 }}</td>
                <td class="border border-gray-400 p-2">{{ hasil.nama_penyedia }}</td>
                <td class="border border-gray-400 p-2">{{ formatCurrency(hasil.total_penyedia) }}</td>
                <td v-for="metode in data.metode_penilaian" :key="metode.nama" class="border border-gray-400 p-2">
                  {{ getPenilaianStatus(hasil, metode.id) }}
                </td>
                <td class="border border-gray-400 p-2">{{ getKualifikasiStatus(hasil) }}</td>
                <!-- <td class="border border-gray-400 p-2">{{ formatCurrency(hasil.total_terkoreksi) }}</td> -->
                <td class="border border-gray-400 p-2">{{ hasil.keterangan }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer Text -->
        <p class="mb-8">
          Demikian Berita Acara ini dibuat dengan penuh rasa tanggung jawab, untuk dapat dipergunakan
          sebagaimana mestinya.
        </p>

        <!-- Signatures -->
       <!--  <div class="mt-8">
          <template v-for="(group, role) in groupedAttendees" :key="role">
            <div class="font-bold mb-4">{{ capitalizeFirst(role) }}</div>
            <div class="space-y-4 mb-8">
              <div v-for="(actor, index) in group" :key="index" class="flex">
                <div class="w-48">{{ index + 1 }}. {{ actor.nama }}</div> -->
                <!-- <div :class="{ 'ml-16': index % 2 === 0, 'ml-48': index % 2 === 1 }">...........................</div> -->
              <!-- </div>
            </div>
          </template>
        </div> -->
      </div>
      <div class="footer-note">
          <div class="p-4 text-center"><i> File ini dihasilkan secara otomatis oleh sistem, silahkan download jika ingin dicetak</i></div>
          <div class="note pt-0 pb-4">
              Sistem TUMBAS<br>
              Universitas Diponegoro
          </div>  
      </div>
    </div>
    <div class="button-container" v-if="!loading">
      <button
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        @click="downloadPdf"
      >
        Download PDF
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import html2pdf from 'html2pdf.js'
import axios from 'axios'
import ProgressSpinner from 'primevue/progressspinner';

const loading = ref(true)

const data = ref({
  nama_pekerjaan: '',
  nama_unit_kerja: '',
  nomor_baep: '',
  tanggal_baep: '',
  nama_hari: '',
  terbilang_hari: '',
  nama_bulan: '',
  terbilang_tahun: '',
  hadir_dalam_rapat: [],
  metode_penilaian: [],
  hasil_evaluasi: []
})

const groupedAttendees = computed(() => {
  const attendees = {}
  data.value.hadir_dalam_rapat.forEach((actor) => {
    if (!attendees[actor.role]) attendees[actor.role] = []
    attendees[actor.role].push(actor)
  })
  return attendees
})

const fetchData = async () => {
  try {
    loading.value = true
    const response = await axios.get(`/baep/${props.dokumen_pengadaan_id}`)    
    data.value = response.data
  } catch (error) {
    console.error('Error fetching BAEP data:', error)
  } finally {
    loading.value = false
  }
}

const formatCurrency = (value) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0
  }).format(value)
}

const downloadPdf = () => {
  const element = document.querySelector('.baep-container')
  const opt = {
    margin: [15, 15, 15, 15], // [top, right, bottom, left] margins in mm
    filename: `BAEP_${data.value.nomor_baep}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { 
      scale: 2,
      letterRendering: true,
      useCORS: true,
      width: 794, // A4 width in pixels at 96 DPI
    },
    jsPDF: { 
      unit: 'mm', 
      format: 'a4', 
      orientation: 'portrait'
    }
  }

  html2pdf().set(opt).from(element).save()
}

onMounted(() => {
  fetchData()
  console.log('Data fetched:', data);
  
})

const props = defineProps({
  dokumen_pengadaan_id: {
    type: Number,
    required: true
  }
})
const capitalizeFirst = (text) => {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

// Helper: check if has valid assessment
const hasValidPenilaian = (entry) => {
  const list = entry?.penilaian
  if (!Array.isArray(list) || list.length === 0) return false
  return list.some(p => p?.nilai !== null && p?.nilai !== undefined && p?.updated_at !== null && p?.updated_at !== undefined)
}

// Helper: check all pass (only for those with valid assessments)
const isLulusSemua = (entry) => {
  if (!hasValidPenilaian(entry)) return false
  const list = entry?.penilaian
  const validAssessments = list.filter(p => p?.nilai !== null && p?.nilai !== undefined && p?.updated_at !== null && p?.updated_at !== undefined)
  return validAssessments.length > 0 && validAssessments.every(p => p?.is_lulus === true)
}

// Helper: get assessment status for individual criteria
const getPenilaianStatus = (hasil, metodeId) => {
  const penilaian = hasil.penilaian.find(p => p.id_bobot_penilaian_dokumen_pengadaan === metodeId)
  
  if (!penilaian || penilaian.nilai === null || penilaian.nilai === undefined || 
      penilaian.updated_at === null || penilaian.updated_at === undefined) {
    return 'Tidak Lulus'
  }
  
  return penilaian.is_lulus ? 'Lulus' : 'Tidak Lulus'
}

// Helper: get overall qualification status
const getKualifikasiStatus = (hasil) => {
  if (!hasValidPenilaian(hasil)) {
    return 'Tidak Lulus'
  }
  
  return isLulusSemua(hasil) ? 'Lulus' : 'Tidak Lulus'
}

// Sorted list: lulus semua first, then by total penawaran ascending
const sortedHasilEvaluasi = computed(() => {
  const list = Array.isArray(data.value.hasil_evaluasi) ? [...data.value.hasil_evaluasi] : []
  return list.sort((a, b) => {
    const aLulus = isLulusSemua(a)
    const bLulus = isLulusSemua(b)
    const aHasValid = hasValidPenilaian(a)
    const bHasValid = hasValidPenilaian(b)
    
    // Priority 1: Those with valid assessments and passed
    if (aLulus && !bLulus) return -1
    if (!aLulus && bLulus) return 1
    
    // Priority 2: Those with valid assessments (but failed) over those without assessments
    if (aHasValid && !bHasValid) return -1
    if (!aHasValid && bHasValid) return 1
    
    // Priority 3: Among those who passed, sort by lowest price
    if (aLulus && bLulus) {
      const aTotal = a?.total_penyedia ?? 0
      const bTotal = b?.total_penyedia ?? 0
      if (aTotal < bTotal) return -1
      if (aTotal > bTotal) return 1
    }
    return 0
  })
})
</script>

<style scoped>
 .footer-note {
      margin-top: 40px;
      border-top: 1px solid #ddd;
      padding-top: 20px;
      font-size: 0.9em;
      color: #666;
  }
  .note {
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      background-color:gainsboro;
      color: rgb(24, 29, 34);
  }
.baep-container {
  padding: 20mm;
  width: 210mm; /* A4 width */
  margin: 0 auto;
  background: white;
  box-sizing: border-box;
}

.button-container {
  width: 210mm;
  margin: 1rem auto;
  text-align: center;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

@media print {
  .baep-container {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  
  .button-container {
    display: none;
  }
}
</style>
